import React from "react";
import { Box } from "@mui/material";
import RequestLogDataTable from "../components/request-log/RequestLogDataTable";
import apiConfig from "../config/appConfig";

const RequestLogs = () => {
  const apiUrl = apiConfig.endpoints.requestLogs.paginated;

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <RequestLogDataTable apiUrl={apiUrl} />
    </Box>
  );
};

export default RequestLogs;
